import { createContext } from 'react';
import type { ContextValue } from './interfaces';

export const QueryDownloaderContext = createContext<ContextValue>(undefined);